import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import MainApp from "../../layouts/MainApp";
import { MDBDataTable } from "mdbreact";
import CreateCustomers from "./CreateCustomers";
import EditCustomer from "./EditCustomer";
import DeleteCustomer from "./DeleteCustomer";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../../redux/actions";
import Pagination from "../../includes/Pagination";
import PrimaryLoader from "../../includes/Loaders/PrimaryLoader";
import ReuseableSearchBar from "../../search/search";
import TableLoader from "../../includes/Loaders/TableLoader";
import PageNumber from "../../includes/PageNumber";

export default function Customers() {
  const allCustomers = useSelector((state) => state.admin.allCustomers);
  const loading = useSelector((state) => state.admin.getCustomerLoader);
  const searching = useSelector((state) => state.admin.searching);

  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const dispatch = useDispatch();

  let params = useParams();

  useEffect(() => {
    dispatch(adminActions.getCustomers(company_id, params.page));
  }, [dispatch, company_id, params]);

  let customerData = allCustomers.data;

  function createTableData() {
    let dataToMap = customerData && customerData.data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((customer, i) => {
        let singleRowArray = {
          name: customer.customer_name,
          email: customer.customer_email,
          contact: customer.customer_phone,
          country: customer.customer_country,
          state: customer.customer_state,
          city: customer.customer_city,
          actions: (
            <div className='d-flex'>
              <EditCustomer customerData={customer} />
              <DeleteCustomer customerData={customer} />
            </div>
          ),
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 200,
      },
      {
        label: "Contact no.",
        field: "contact",
        sort: "asc",
        width: 100,
      },
      {
        label: "Country",
        field: "country",
        sort: "asc",
        width: 100,
      },
      {
        label: "State",
        field: "state",
        sort: "asc",
        width: 100,
      },
      {
        label: "City",
        field: "city",
        sort: "asc",
        width: 150,
      },
      {
        label: "Actions",
        field: "actions",
        sort: "asc",
        width: 150,
      },
    ],
    rows: dataSet,
  };

  return (
    <MainApp>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className='main-content-padding'>
          <div className='main-content'>
            <div className='d-flex justify-content-between mb-3'>
              <h1 className='mr-2'>Customers</h1>
              <CreateCustomers />
            </div>
            <div className='separator-breadcrumb border-top' />
            <div className='search-page'>
              <PageNumber data={customerData} route='customers' />
              <ReuseableSearchBar
                companyId={company_id}
                page={params.page}
                searchAction={adminActions.searchAllCustomers}
                clearSearchResultsAction={
                  adminActions.getCustomers
                }></ReuseableSearchBar>
            </div>

            <div>
              {searching ? (
                <TableLoader />
              ) : (
                    <MDBDataTable
                      responsive
                  theadColor='MDBTableHeader'
                  entries={8}
                  entriesOptions={[8, 10, 15]}
                  hover
                  noBottomColumns
                 bordered
                  maxHeight='400px'
                  data={data}
                  paging={false}
                  searching={false}
                />
              )}
            </div>
            <Pagination data={customerData} route='customers' />
            {/* end of row*/}
            {/* end of main-content */}
          </div>
        </div>
      )}
    </MainApp>
  );
}
